import React from 'react';
import { useSelector } from 'react-redux';
import HomeCarousel from '../HomeCarousel';
import { Wrapper } from './styled';

const HomeHeader = () => {
  const { data } = useSelector((state: any) => state.bannerList);
  return (
    <Wrapper id="enrollmentturn" data-testid="cmp-home-header">
      <HomeCarousel items={data} />
      <div id="startTutorial" />
    </Wrapper>
  );
};

export default HomeHeader;
